import {
  Organization,
} from "model/organizationModel";
import createContext, { Action } from "./createDataContext";
import { DispatchAction } from "./createDataContext";
import { CONSTANTS } from "common";

const SET_ORGANIZATION_FIRST_SEARCH = "SET_ORGANIZATION_FIRST_SEARCH";
const REMOVE_ORGANIZATION_FIRST_SEARCH = "REMOVE_ORGANIZATION_FIRST_SEARCH";
const SET_ORGANIZATIONS = "SET_ORGANIZATIONS";
const SET_SELECTED_ORGANIZATION = "SET_SELECTED_ORGANIZATION";
const RESET_ORGANIZATIONS = "RESET_ORGANIZATIONS";
const SET_ORGANIZATIONS_AND_SELECTED_ORGANIZATION =
  "SET_ORGANIZATIONS_AND_SELECTED_ORGANIZATION";

const INITIAL_STATE = {
  organizationsFirstSearch: false as boolean,
  organizations: [] as Organization[],
  selectedOrganization: null as Organization | null,
};

const getSelectedOrganizationStorageKey = () => {
  const user = JSON.parse(localStorage.getItem(CONSTANTS.STORE_USER) || "null");
  return user?.userId
    ? `${CONSTANTS.STORE_SELECTED_ORGANIZATION_ID}-${user.userId}`
    : CONSTANTS.STORE_SELECTED_ORGANIZATION_ID;
};

const alignSelectedToLocal = (selectedOrganization: Organization | null) => {
  const storageKey = getSelectedOrganizationStorageKey();
  if (selectedOrganization?.id) {
    localStorage.setItem(
      storageKey,
      String(selectedOrganization.id),
    );
  } else {
    localStorage.removeItem(storageKey);
  }
};
const reducer = (state: typeof INITIAL_STATE, action: Action) => {
  switch (action.type) {
    case SET_ORGANIZATION_FIRST_SEARCH: {
      return { ...state, organizationsFirstSearch: true };
    }
    case REMOVE_ORGANIZATION_FIRST_SEARCH: {
      return { ...state, organizationsFirstSearch: false };
    }
    case SET_ORGANIZATIONS: {
      return { ...state, organizations: action.payload };
    }
    case SET_ORGANIZATIONS_AND_SELECTED_ORGANIZATION: {
      const { organizations, selectedOrganization } = action.payload;
      alignSelectedToLocal(selectedOrganization);
      return { ...state, organizations, selectedOrganization };
    }
    case SET_SELECTED_ORGANIZATION: {
      const selectedOrganization = action.payload as Organization;
      alignSelectedToLocal(selectedOrganization);
      return { ...state, selectedOrganization: action.payload };
    }
    case RESET_ORGANIZATIONS: {
      return INITIAL_STATE;
    }
    default: {
      return state;
    }
  }
};

const addOrganizationsFirstSearch: DispatchAction<{}, void> =
  (dispatch) => () => {
    dispatch({ type: SET_ORGANIZATION_FIRST_SEARCH });
  };
const removeOrganizationsFirstSearch: DispatchAction<{}, void> =
  (dispatch) => () => {
    dispatch({ type: REMOVE_ORGANIZATION_FIRST_SEARCH });
  };

const setOrganizations: DispatchAction<Organization[], void> =
  (dispatch) => (organizations) => {
    const localSelectedOrganizationId = localStorage.getItem(
      getSelectedOrganizationStorageKey(),
    );
    const selectedOrganization = organizations.find(
      (o) => String(o.id) === localSelectedOrganizationId,
    );
    if (selectedOrganization) {
      dispatch({
        type: SET_ORGANIZATIONS_AND_SELECTED_ORGANIZATION,
        payload: {
          organizations,
          selectedOrganization,
        },
      });
    } else {
      if (organizations.length > 0) {
        dispatch({
          type: SET_ORGANIZATIONS_AND_SELECTED_ORGANIZATION,
          payload: { organizations, selectedOrganization: organizations[0] },
        });
      } else {
        dispatch({ type: SET_ORGANIZATIONS, payload: organizations });
      }
    }
  };
const setSelectedOrganization: DispatchAction<Organization | null, void> =
  (dispatch) => (selectedOrganization) => {
    dispatch({
      type: SET_SELECTED_ORGANIZATION,
      payload: selectedOrganization,
    });
  };
const resetOrganizations: DispatchAction<void, void> =
  (dispatch) => () => {
    dispatch({ type: RESET_ORGANIZATIONS });
  };

const actions = {
  addOrganizationsFirstSearch,
  removeOrganizationsFirstSearch,
  setOrganizations,
  setSelectedOrganization,
  resetOrganizations,
  // ACTIONS
};
type ActionsType = typeof actions;
export type ContextType = {
  state: typeof INITIAL_STATE;
  actions: {
    [Property in keyof ActionsType]: ReturnType<ActionsType[Property]>;
  };
};
export const { Context, Provider } = createContext<
  ContextType,
  typeof INITIAL_STATE,
  typeof actions
>(reducer, actions, INITIAL_STATE);
